export default "__VITE_ASSET__B2lh8sCT__"